import { render, staticRenderFns } from "./PaymentSubgroupsChannels.vue?vue&type=template&id=b2e7e630&scoped=true&"
import script from "./PaymentSubgroupsChannels.vue?vue&type=script&lang=js&"
export * from "./PaymentSubgroupsChannels.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSubgroupsChannels.vue?vue&type=style&index=0&id=b2e7e630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e7e630",
  null
  
)

export default component.exports